import React from "react";
import { useDropzone } from "react-dropzone";
import { Card, Stack, Button } from "@mui/material";

const drop = {
  fontSize: "11px",
  paddingTop: "13px",
  alignItems: "center",
};
const upload = {
  height: "15rem",
  marginTop: "2.5rem",
  display: "flex",
  justifyContent: "center",
  backgroundColor: "#F0F1F4",
  boxShadow: " none",
  marginTop: "0.5rem",
};
const para = {
  fontSize: "11px",
  paddingTop: "3px",
};

const DropZoneUpload = (props) => {
  const { handleChangeFile } = props;
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      accept: {
        // "image/*": [],
        // "image/jpeg": [],
        // "image/png": [],
        // "image/jpg": [],
        "application/vnd.ms-excel": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          [],
        "application/docx": [],
        "application/pdf": [],
        "text/plain": [],
        "application/msword": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
      },
      onDrop: handleChangeFile,
      multiple: false,
      maxSize: 1000000,
    });

  const acceptedFileItems = acceptedFiles.map((file) => {
    return <div style={{ paddingBottom: "10px" }}>{file.path}</div>;
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => {
    console.log("file123", file, errors);
    return <p>File is not supported</p>;
  });

  return (
    <section className="container">
      {/* <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} multiple={false} />
        <p style={para}>Drag 'n' drop file here, or click to select file</p>
        <em>(Only *.jpeg, *.png and *.pdf file will be accepted)</em>
      </div> */}
      <Card style={upload}>
        <Stack
          // {...getRootProps()}
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{
            border: "2px dotted #25d5a1",
            width: "90%",
            display: "flex",
            justifyContent: "center",
            margin: "20px 0 20px 0",
            flexDirection: "column",
            "& .MuiButton-root:hover": {
              background: `#feb62c !important`,
              color: `#F0F1F4   !important`,
            },
          }}
        >
          <button
            {...getRootProps()}
            type="button"
            component="label"
            style={{
              width: "40%",
              height: "30%",
              border: "none",
              borderRadius: "22px",
              backgroundColor: "#feb62c",
              color: "white",
              textTransform: "capitalize !important",
              fontFamily: "inter !important",
            }}
          >
            <input {...getInputProps()} multiple={false} />
            Upload a File
          </button>

          <p style={drop}>Files must be xlsx.xls and</p>
          <p style={para}>Max File size 10MB</p>
        </Stack>
      </Card>
      <aside>
        {/* <em style={{ color: "red" }}>{acceptedFileItems}</em> */}
        <em style={{ color: "red" }}>{fileRejectionItems}</em>
      </aside>
      <p>{}</p>
    </section>
  );
};

export default DropZoneUpload;
